import { render } from "./BannerWeaponBow.vue?vue&type=template&id=d0179526&scoped=true"
import script from "./BannerWeaponBow.vue?vue&type=script&lang=js"
export * from "./BannerWeaponBow.vue?vue&type=script&lang=js"

import "./BannerWeaponBow.vue?vue&type=style&index=0&id=d0179526&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0179526"]])

export default __exports__